const ActionFilters = Object.freeze({
  Completed: 'Delivered',
  Pending: 'Scheduled',
  Paused: 'Paused',
});

const ActionFiltersTranslated = Object.freeze({
  Completed: 'complete',
  Pending: 'pending',
  Incomplete: 'pending',
  Delete: 'delete',
  Paused: 'paused',
});

const TypeFilters = Object.freeze({
  Email: 'Email',
  Sms: 'Text',
});

const TypeFiltersTranslated = Object.freeze({
  Email: 'send_email_scheduled',
  Text: 'send_sms_scheduled',
});

const HeadersPending = [
  {
    text: 'Type',
    value: 'action',
    sortable: false,
  },
  {
    text: 'Send from',
    value: 'input',
    sortable: false,
  },
  {
    text: 'Subject',
    value: 'subject',
    sortable: false,
    align: 'center',
  },
  {
    text: 'Scheduled On',
    value: 'due_at',
  },
  {
    text: '',
    sortable: false,
  },
];

const HeadersCompleted = [
  {
    text: 'Type',
    value: 'action',
    sortable: false,
  },
  {
    text: 'Send from',
    value: 'input',
    sortable: false,
  },
  {
    text: 'Subject',
    value: 'subject',
    sortable: false,
    align: 'center',
  },
  {
    text: 'Delivered On',
    value: 'updated_at',
  },
];

const HeadersPaused = [
  {
    text: 'Type',
    value: 'action',
    sortable: false,
  },
  {
    text: 'Send from',
    value: 'input',
    sortable: false,
  },
  {
    text: 'Subject',
    value: 'subject',
    sortable: false,
    align: 'center',
  },
  {
    text: 'Paused On',
    value: 'updated_at',
  },
  {
    text: 'Scheduled On',
    value: 'due_at',
  },
  {
    text: '',
    sortable: false,
  },
];


export {
  ActionFilters,
  ActionFiltersTranslated,
  TypeFilters,
  TypeFiltersTranslated,
  HeadersPending,
  HeadersCompleted,
  HeadersPaused,
}
